import { BRAND } from '@rydres/shared';
import { Logo } from '@rydres/ui';

/** rydres.com with no handle: a short explanation for drivers. Riders arrive with a driver's link. */
export function Landing() {
  return (
    <div className="mx-auto flex min-h-screen max-w-xl flex-col justify-center px-6 py-16">
      <h1><Logo size={52} wordmark="brand" className="text-4xl" /></h1>
      <p className="mt-3 text-lg text-ink2">{BRAND.tagline}</p>
      <p className="mt-6 text-sm text-muted">
        {BRAND.name} is booking and record-keeping software for licensed California charter-party
        (TCP) drivers. Each driver has a personal booking page; riders book directly with the
        driver, who sets every price and provides the transportation.
      </p>
      <a href={BRAND.appOrigin} className="mt-8 inline-block rounded-2xl bg-brand px-5 py-3 text-center font-bold text-on-brand shadow-soft brand-press">
        Driver sign in
      </a>
      <p className="mt-10 text-xs text-muted">
        {BRAND.name} is operated by {BRAND.operator}. It provides software only and is not a charter-party carrier. <a className="underline" href="/privacy">Privacy Policy</a> · <a className="underline" href="/terms">Terms of Use</a>
      </p>
    </div>
  );
}
